<template>
  <main class="auth-layout">
    <AppLogo class="auth-layout__logo" />
    <RouterView />
  </main>
</template>

<script setup lang="ts">
import AppLogo from '@/components/AppLogo.vue'
</script>

<style scoped lang="scss">
.auth-layout {
  position: relative;
  height: 100%;

  &__logo {
    position: absolute;
    top: 16px;
    left: 16px;

    @include mobile {
      top: 30px;
      left: 30px;
    }

    @include tablet {
      top: 50px;
      left: 50px;
    }
  }
}
</style>
